import {isPublicProfilePath} from '../../shared/profile-url'

export const getNotificationBadgeRouteState = ({pathname, profileUserId, sessionUser, containerName}) => {
    const pathParts = pathname.split('/').filter(Boolean)
    const publicProfile = isPublicProfilePath(pathname)
    const profileUserSegment = publicProfile ? (pathParts[0] === 'u' ? pathParts[1] : pathParts[0]) : null
    const isCurrentPublicProfile = publicProfile
        && (profileUserSegment === sessionUser?.id || profileUserSegment === sessionUser?.url)
    const publicProfileSubpath = isCurrentPublicProfile ? pathParts[pathParts[0] === 'u' ? 2 : 1] || '' : null
    const currentProfileSubpath = pathname.startsWith('/profile') && !profileUserId
        ? pathParts[1] || ''
        : publicProfileSubpath
    const hasCurrentProfileSubmenu = currentProfileSubpath != null
        && !['settings', 'more'].includes(currentProfileSubpath)
    const isNetworkRoot = pathname.startsWith('/network') && !profileUserId
    return {
        notificationsHidden: containerName !== 'notifications' && hasCurrentProfileSubmenu,
        notificationMenuHidden: containerName === 'notifications' && currentProfileSubpath === 'notifications',
        networkHidden: containerName !== 'network' && isNetworkRoot,
    }
}
